import { apiSlice } from "@/services/api-slice";
import { APIResponse } from "@/types/custom-http";
import { Workspace, WorkspaceInfo, CreateWorkspace, UpdateWorkspace } from "./workspaces.interface";

export const workspacesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWorkspaces: builder.query<APIResponse<Workspace[]>, void>({
      query: () => ({ url: "auth/workspaces" }),
      providesTags: ["Workspaces"],
    }),

    getWorkspacesInfo: builder.query<APIResponse<WorkspaceInfo[]>, void>({
      query: () => ({ url: "auth/workspaces/info" }),
      providesTags: ["Workspaces"],
    }),

    searchWorkspaces: builder.query<APIResponse<Workspace[]>, string>({
      query: (search) => ({
        url: "auth/workspaces/search",
        params: { search },
      }),
      providesTags: ["Workspaces"],
    }),

    getWorkspaceById: builder.query<APIResponse<Workspace>, number>({
      query: (id) => ({ url: `auth/workspaces/${id}` }),
      providesTags: (_result, _error, id) => [{ type: "Workspaces", id }],
    }),

    createWorkspace: builder.mutation<APIResponse<Workspace>, CreateWorkspace>({
      query: (data) => ({
        url: "auth/workspaces",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Workspaces"],
    }),

    updateWorkspace: builder.mutation<APIResponse<Workspace>, { id: number; changes: UpdateWorkspace }>({
      query: ({ id, changes }) => ({
        url: `auth/workspaces/${id}`,
        method: "PATCH",
        body: changes,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "Workspaces", id }, "Workspaces"],
    }),
  }),
});

export const {
  useGetWorkspacesQuery,
  useLazyGetWorkspacesQuery,
  useGetWorkspacesInfoQuery,
  useLazyGetWorkspacesInfoQuery,
  useSearchWorkspacesQuery,
  useLazySearchWorkspacesQuery,
  useGetWorkspaceByIdQuery,
  useLazyGetWorkspaceByIdQuery,
  useCreateWorkspaceMutation,
  useUpdateWorkspaceMutation,
} = workspacesApi;
